import CardThumb from '@/molecules/CardThumb';
import Pagination from '@/molecules/Pagination';
import ListHeader from '@/organisms/ListHeader';
import { CARDS_PER_PAGE } from 'constants/itemsPerPage';
import ModalClassicLayout from 'context/Modal/layout/Classic';
import useCardsFilterData from 'hooks/queries/cards/useCardsFilterData';
import convertToDotNotation from 'utils/filters/convertToDotNotation';
import usePrintingCardListModal from './hooks';
import Spinner from '@/atoms/loader/Spinner';
import { useTranslation } from 'react-i18next';

type Props = { closeModal: () => void; printingPage: string };

const PrintingCardList = ({ closeModal, printingPage }: Props) => {
  /*
    TODO: mutualize with /src/context/Modal/views/TradeList/CardTradeList/index.tsx
    new modal component `CollectionCardActionList` based on CardTradeList
    displays a list of cards with filters, pagination and actions
   */
  const {
    cards,
    filters,
    totalItems,
    handleCardClick,
    onFilterSubmit,
    clearFilters,
    onPageChange,
    setOrder,
    isLoading,
  } = usePrintingCardListModal({
    printingPage,
  });
  const { filterData } = useCardsFilterData();
  const { page, ...filtersValues } = convertToDotNotation(filters);
  const { t } = useTranslation();

  return (
    <ModalClassicLayout closeModal={closeModal} submitLabel={t('add-card')} title="add-card">
      <ListHeader
        filterData={filterData}
        filtersValues={filtersValues}
        loading={false}
        onClear={clearFilters}
        onFilterSubmit={onFilterSubmit}
        setOrder={setOrder}
        totalItems={totalItems}
        updateQueryParams={false}
      />
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 items-end">
        {cards?.map(({ imagePath, stats, '@id': id, name, isSuspended }) => (
          <button key={id} onClick={() => handleCardClick(id)} type="button">
            <p className="title-6 pb-2">{name}</p>
            <CardThumb
              alt=""
              imagePath={imagePath}
              inMyCollection={stats?.inMyCollection}
              inMySale={stats?.inMySale || 0}
              isExclusive={!!stats?.isExclusive}
              isSuspended={isSuspended}
              numberCopyAvailable={stats?.numberCopyAvailable}
            />
          </button>
        ))}
        {isLoading && <Spinner />}
      </div>
      <Pagination
        itemsPerPage={CARDS_PER_PAGE}
        onPageChange={onPageChange}
        page={filters.page}
        totalItems={totalItems}
      />
    </ModalClassicLayout>
  );
};

export default PrintingCardList;
